import { render, staticRenderFns } from "./g-location.vue?vue&type=template&id=f78a7a0a&scoped=true"
import script from "./g-location.vue?vue&type=script&lang=js"
export * from "./g-location.vue?vue&type=script&lang=js"
import style0 from "./g-location.vue?vue&type=style&index=0&id=f78a7a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78a7a0a",
  null
  
)

export default component.exports